import i18n from './../../../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../../../core/components/input-widget/BaseModel";

export default class Language extends BaseModel {
  name = null;
  is_primary = false;

  static TRANSLATABLE_FIELDS = [];

  rules = {
    name: 'required'
  };

  attributeLabels = {
    name: i18n.t('Language'),
    is_primary: i18n.t('Primary Language')
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(Language);
